import { createFileRoute } from '@tanstack/react-router';

import { IndexPage } from '#/routes/(root)/-components/IndexPage.tsx';

export const Route = createFileRoute('/(root)/')({
  component: IndexPage,
});
